<template>
  <div>
    <div>
      <CvOfferAlerts :validation="false" :offer="offer"></CvOfferAlerts>
    </div>
    <div class="vertical_space"></div>
    <div class="modal_footer is-justify-content-space-evenly">
      <a @click="close" class="button is-danger">Cancel</a>
      <a @click="submit" :class="{ 'is-loading': isSubmitting }" class="button is-info">Submit Strong</a>
    </div>
  </div>
</template>
<script>
import CvOfferAlerts from '@/components/CvOfferAlerts.vue'

export default {
  name: 'alert-warning-content',
  props: {
    offer: {
      type: Object,
      default: () => ({})
    },
    closeModal: {
      type: Function,
      default: () => {}
    },
    submitModal: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      isSubmitting: false
    }
  },
  components: {
    CvOfferAlerts
  },
  methods: {
    close () {
      this.closeModal(this.$attrs.payload.modal_id)
    },
    submit () {
      try {
        this.isSubmitting = true
        this.submitModal(this.$attrs.payload.modal_id)
      } catch (e) {
        this.isSubmitting = false
      }
    }
  }
}
</script>
